import Env from "../base/env";
import Channels from "../base/channels";
import gsap from "gsap";

class Launcher {
  constructor() {
    if (Env.$launcher == null) return false;
    // Dom
    this.view = Env.$launcher;

    // Flags
    this.NO_INTRO = false;
    this.LAUNCHED = false;
    // FNs
    this.setup();
  }

  noLaunch() {
    gsap.delayedCall(0.15, () => {
      Env.$html.classList.add("ui-ready");
      gsap.delayedCall(0.1, () => Channels.emit("launcher::exit"));
      this.LAUNCHED = true;
    });
    gsap.delayedCall(0.25, () => {
      Env.$master.removeChild(this.view);
      Env.$html.classList.add("ui-finalized");
    });
  }

  reveal() {
    const tl = gsap.timeline();

    tl.add([
      gsap.fromTo(
        this.view,
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
          ease: "cubic.out",
          duration: 0.25,
          delay: 0.3,
          onStart: () => {
            Env.$html.classList.add("ui-ready");
            gsap.delayedCall(0.1, () => Channels.emit("launcher::exit"));
            gsap.delayedCall(0.5, () =>
              Env.$html.classList.add("ui-finalized")
            );
            this.LAUNCHED = true;
          },
          onComplete: () => {
            Env.$master.removeChild(this.view);
          },
        }
      ),
    ]);
  }

  setup() {
    Env.framework.toolbox.resetScroll();
    if (this.NO_INTRO) {
      this.noLaunch();
    } else {
      this.reveal();
    }
  }
}

export default Launcher;
